import { styled } from '@mui/system';
import { Box } from '@mui/material';

export const ReportingContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const StyledForm = styled('form')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(1),

  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    color: theme.palette.text.secondary,
  },
}));
